import { apiSlice } from './apiSlice.js'



export const exchangeSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExchangeRates: builder.query({
      query: () => '/api/exchange-rates',
      keepUnusedDataFor: 300,
    }),
  }),
});



export const useGetExchangeRatesQuery = (arg, options = {}) => exchangeSlice.useGetExchangeRatesQuery(arg, {
  pollingInterval: 15 * 60 * 1000,
  refetchOnMountOrArgChange: 300,
  ...options,
});